import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  DevicesApi,
  type PostDevicesSearchRequestBody,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

type Params = {
  filter: PostDevicesSearchRequestBody
  offset: number
  limit: number
}

/**
 * キオスク端末 (Device) をフィルター検索して一覧取得する。
 * キオスク端末名は部分一致、所属現場は現場ノードIDで絞り込む。
 */
export const useQuerySearchDevices = ({ filter, offset, limit }: Params) =>
  useQuery({
    queryKey: queryKeys.devices({ filter, offset, limit }),
    queryFn: () =>
      baseClient
        .getApi(DevicesApi)
        .searchDevices({
          offset,
          limit,
          postDevicesSearchRequestBody: filter,
        })
        .catch(handleHTTPError),
    // ページ送り・絞り込み変更時に一覧が一瞬空になるのを防ぐ
    placeholderData: keepPreviousData,
  })
